import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSiteContent, updateSiteContent } from "../../../services/operations/siteContentApi";
import { defaultPlanContent } from "../Footer/Plans/Plans";

const sections = [
  { key: "plans", label: "Plans tab", kind: "json" },
  { key: "privacy-policy", label: "Privacy Policy" },
  { key: "terms-and-conditions", label: "Terms and Conditions" },
  { key: "refund-policy", label: "Refund Policy" },
  { key: "grievance-policy", label: "Grievance Policy" },
];

export default function PageContentManager() {
  const { token } = useSelector((state) => state.auth);
  const [active, setActive] = useState(sections[0]);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getSiteContent(active.key).then((data) => {
      const initial = data ?? (active.kind === "json" ? defaultPlanContent : "");
      setValue(active.kind === "json" ? JSON.stringify(initial, null, 2) : initial);
      setLoading(false);
    });
  }, [active]);

  const save = async () => {
    let content = value;
    if (active.kind === "json") {
      try { content = JSON.parse(value); }
      catch (_error) { return window.alert("The Plans content is not valid JSON."); }
    }
    setLoading(true);
    await updateSiteContent(active.key, content, token);
    setLoading(false);
  };

  return <div className="page-content-admin">
    <h1>Edit Website Content</h1>
    <p>Changes publish directly to the selected website page.</p>
    <div className="page-content-tabs">{sections.map((section) => <button type="button" key={section.key} className={active.key === section.key ? "active" : ""} onClick={() => setActive(section)}>{section.label}</button>)}</div>
    <label htmlFor="site-content-editor">{active.label} content</label>
    {!value && active.kind !== "json" && <p className="page-content-note">No replacement has been published yet. The current built-in policy remains visible until you save content here. You can paste fully formatted text using headings with #, lists with -, and blank lines between paragraphs.</p>}
    <textarea id="site-content-editor" value={value} onChange={(event) => setValue(event.target.value)} spellCheck="true" disabled={loading} />
    <button className="page-content-save" type="button" disabled={loading || !value.trim()} onClick={save}>{loading ? "Please wait…" : `Save ${active.label}`}</button>
  </div>;
}
